import { render } from "./PrinterInList.vue?vue&type=template&id=2b5296c2"
import script from "./PrinterInList.vue?vue&type=script&lang=js"
export * from "./PrinterInList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__